// Department service for API calls
import {Department} from '../types';
import {fetchWithErrorHandling, guestPrefix, isAuthenticated} from './apiUtils';

export class DepartmentService {
  // Event to notify when departments are updated
  private static notifyDepartmentsUpdated(departments: Department[]) {
    if (typeof window !== 'undefined') {
      const event = new CustomEvent('departmentsUpdated', { detail: departments });
      window.dispatchEvent(event);
    }
  }

  static async getDepartments(productSearch?: string): Promise<Department[]> {
    try {
      // Build URL - productSearch only supported for authenticated users
      let url: string;
      const base = `/api/v2${guestPrefix()}/departments`;
      if (productSearch && isAuthenticated()) {
        url = `${base}?productSearch=${encodeURIComponent(productSearch)}`;
      } else {
        url = base;
      }
      const departments = await fetchWithErrorHandling<Department[]>(url, undefined);

      // If productSearch is provided, notify listeners
      if (productSearch) {
        DepartmentService.notifyDepartmentsUpdated(departments);
      }

      return departments;
    } catch {
      // Fall back to local JSON file
      try {
        const { default: localDepartments } = await import('../data/departments.json');
        return localDepartments as Department[];
      /* c8 ignore start */
      } catch (localError) {
        console.error('Failed to load departments from both API and local data:', localError);
        throw new Error('Unable to load departments from both API and local data.');
      }
      /* c8 ignore stop */
    }
  }
}
